import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconArrowRight: React.FC<Props> = ({
  width = 18,
  height = 14,
  color = '#23282E',
  // disabled = false,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0766 7.23928C17.0449 7.31594 16.9992 7.38502 16.9417 7.44252L11.1084 13.2759C10.9867 13.3975 10.8267 13.4592 10.6667 13.4592C10.5067 13.4592 10.3466 13.3984 10.225 13.2759C9.98081 13.0317 9.98081 12.6358 10.225 12.3917L14.9916 7.62502H1.5C1.155 7.62502 0.875 7.34502 0.875 7.00002C0.875 6.65502 1.155 6.37502 1.5 6.37502H14.9908L10.2242 1.60837C9.98 1.36421 9.98 0.968345 10.2242 0.724179C10.4683 0.480012 10.8642 0.480012 11.1084 0.724179L16.9417 6.55751C16.9992 6.61501 17.0449 6.68409 17.0766 6.76076C17.1399 6.91409 17.1399 7.08594 17.0766 7.23928Z"
      fill={color}
    />
  </svg>
);

export default IconArrowRight;
